const confirmClassificationData = [
  {
    id: 0,
    name: 'Otras Categorías',
  },
  {
    id: 1,
    name: 'Otros Otra vez',
  },
  {
    id: 2,
    name: 'Otros'
  },
  {
    id: 3,
    name: 'Esto no deberia mostrarse'
  },
  {
    id: 4,
    name: 'Esto no deberia mostrarse tampoco'
  },
]

export default confirmClassificationData
